import React, { useEffect, useState, useMemo } from 'react';
import CustomSelect from '../../components/CustomSelect';
import { commonBackInfo, upperAndLowerFuzzyQuery } from '../../utils';
import {
  useGetCustomSelectButtonElement,
  useSetSelectDefaultValue,
} from '../../hooks/init';
import { competitorGamePlaceholder } from '../../constants/placeholder';
import type { GameListType } from '../../types';
import './index.scss';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';
import RenderGameIcon from '@op/components/RenderImg/renderGameIcon';
export default function CompetitorGameListSelect({
  onChange,
  defaultValue,
  filterValue,
  filterOptions,
  gameInfo,
  defaultKey,
  oriDefaultFilter,
  backOriDefaultValue,
  lang,
}: GameListType) {
  // 搜索的数据
  const [searchValue, setSearchValue] = useState('');

  const gameOptions = useMemo(() => {
    return (filterOptions || []).map((item: any) => {
      return {
        text: item.entity_name,
        icon: item.cover,
        value: item.edition_unified_id,
      };
    });
  }, [filterOptions]);

  const selectOptions = useMemo(() => {
    return upperAndLowerFuzzyQuery(gameOptions, searchValue);
  }, [gameOptions, searchValue]);

  const basicOptionsList = useMemo(() => {
    return gameOptions.map((item: any) => item.value);
  }, [gameOptions]);

  const {
    selects: selectGameList,
    setSelects: setSelectGameList,
    diffClassName,
  } = useSetSelectDefaultValue<string>({
    defaultValue,
    filterValue,
    defaultKey: 'games',
    options: basicOptionsList,
    oriDefaultFilter,
    backOriDefaultValue,
    mustFilter: true,
    mustFilterValueFunc: (item: any) =>
      typeof item === 'string' ? item : item?.edition_unified_id,
    finallyDealwithSelected: (options) => {
      if (options.length === 1 && options[0] === '99999') {
        return basicOptionsList;
      }
      return options.map((item: any) =>
        typeof item === 'string' ? item : item?.edition_unified_id,
      );
    },
  });

  const { customSelectRef, getButtonElement } =
    useGetCustomSelectButtonElement();

  const getGameListInfo = () => {
    const result = (filterOptions || []).reduce((pre: any, cur: any) => {
      if (selectGameList.includes(cur.edition_unified_id)) {
        const { edition_unified_id, entity_type, id_type, release_time } = cur;
        return [
          ...pre,
          {
            edition_unified_id,
            entity_type,
            id_type,
            release_time,
          },
        ];
      }
      return pre;
    }, []);
    return result;
  };

  useEffect(() => {
    const [text, isAll] = getButtonElement();
    onChange?.(
      'games',
      commonBackInfo(
        { games: getGameListInfo(), allCompetitorGame: isAll },
        { competitorGames: text },
        { isAll, needChangeEntity: false },
      ),
    );
  }, [selectGameList, basicOptionsList]);

  return (
    <div className={`competitor-game-list-wrapper ${diffClassName}`}>
      <CustomSelect
        ref={customSelectRef}
        searchInfo={[searchValue, setSearchValue]}
        placeholderText={competitorGamePlaceholder[lang]}
        onClear={() => setSelectGameList([])}
        selectOptionsInfo={[selectGameList, setSelectGameList]}
        options={selectOptions}
        showNumber={1}
        matchButtonWidth={false}
        basicOptions={gameOptions}
        pointKey={FilterButtonPoint.genreGameList}
        boxClassName="genre-game-list-select"
        optionItemRender={(text: string, _value: any, item: any) => {
          const icon = item.icon;
          return (
            <div className="genre-game-list-select-item">
              <RenderGameIcon
                className="game-icon"
                gameInfo={{ cover: icon }}
              ></RenderGameIcon>
              <span className="genre-game-list-select-item-text">{text}</span>
            </div>
          );
        }}
      ></CustomSelect>
    </div>
  );
}
